module.exports = __webpack_public_path__ + "img/receipt8.03201e9d.svg";